<template>
  <div class="pure-g">
    <div class="pure-u-md-1-5 pure-u-lg-1-4"></div>
    <div class="pure-u-1 pure-u-md-3-5 pure-u-lg-1-2">
      <div class="content box padding-30-reactive">
        <p class="text-align-center">
          You’re on the list! <br> Verde will be released exclusively on the <strong class="underline">Tavour app September 8th. <br> Download the app now so you'll be ready!</strong>

        </p>
        <div class="text-align-center">
          <a href="https://itunes.apple.com/us/app/tavour/id956371806?mt=8">
            <img class="share-buttons" alt="Download on the App Store" src="../../assets/images/ios.png">
          </a>
          <a href='https://play.google.com/store/apps/details?id=com.tavour.app&hl=en&utm_source=tavour.com&utm_campaign=user_home&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
            <img class="share-buttons" width="auto" alt="Get it on Google Play" src="../../assets/images/android.png"/>
          </a>
        </div>
        <!--<img class="pure-u-1" src="../../assets/images/verde.jpg">-->
      </div>
    </div>
  </div>
</template>

<script>
  import store from '../../lib/store';

  export default {
    name: 'SuccessKUIUAnchorage',
    created() {
      /* global ga */
      ga('send', 'pageview', `/${store.get('subscription')}/Success`);
      store.clear();
    },
  };
</script>

<style>
  img {
    width: 100%;
  }
  .text-align-center {
    text-align: center;
  }
  .share-buttons {
    display: inline;
    height: 40px;
    width: 130px;
    padding-left: 10px;
    padding-right: 10px;
  }
  .underline {
    text-decoration: underline;
  }
  @media screen and (max-width: 35.5em) {
    .share-buttons {
      display: inline;
      height: auto;
      width: 40%;
    }
  }
  .content {
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// SuccessKUIUAnchorage.vue?4cf9dbe0